"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FC, useCallback } from "react";
import ReactSlider from "react-slider";
export interface SliderProps {
  value: number | undefined;
  onChange?: (value: number, index: number) => void;
  min: number;
  max: number;
  minLabel?: string;
  maxLabel?: string;
  step?: number;
  label?: string;
  className?: string;
  marks?: boolean;
  markValues?: boolean;
  suffix?: string;
  disabled?: boolean;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  formatValue?: (value: number) => string;
}
const Slider: FC<SliderProps> = t0 => {
  const $ = _c(54);
  let ariaDescribedBy;
  let ariaLabel;
  let className;
  let formatValue;
  let label;
  let maxLabel;
  let minLabel;
  let props;
  let suffix;
  if ($[0] !== t0) {
    ({
      className,
      minLabel,
      maxLabel,
      label,
      suffix,
      ariaLabel,
      ariaDescribedBy,
      formatValue,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaDescribedBy;
    $[2] = ariaLabel;
    $[3] = className;
    $[4] = formatValue;
    $[5] = label;
    $[6] = maxLabel;
    $[7] = minLabel;
    $[8] = props;
    $[9] = suffix;
  } else {
    ariaDescribedBy = $[1];
    ariaLabel = $[2];
    className = $[3];
    formatValue = $[4];
    label = $[5];
    maxLabel = $[6];
    minLabel = $[7];
    props = $[8];
    suffix = $[9];
  }
  let disabled;
  let forwardedProps;
  let rawOnChange;
  let t1;
  let t2;
  let t3;
  if ($[10] !== props) {
    ({
      value: t1,
      onChange: rawOnChange,
      min: t2,
      max: t3,
      disabled,
      ...forwardedProps
    } = props);
    $[10] = props;
    $[11] = disabled;
    $[12] = forwardedProps;
    $[13] = rawOnChange;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    disabled = $[11];
    forwardedProps = $[12];
    rawOnChange = $[13];
    t1 = $[14];
    t2 = $[15];
    t3 = $[16];
  }
  const rawValue = t1 === undefined ? 0 : t1;
  const rawMin = t2 === undefined ? 0 : t2;
  const rawMax = t3 === undefined ? 100 : t3;
  const value = rawValue - rawMin;
  let t4;
  if ($[17] !== rawMin || $[18] !== rawOnChange) {
    t4 = (nextValue, index) => {
      rawOnChange && rawOnChange(nextValue + rawMin, index);
    };
    $[17] = rawMin;
    $[18] = rawOnChange;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const onChange = t4;
  const max = rawMax - rawMin;
  let t5;
  if ($[20] !== label) {
    t5 = <label className="text-app-title-1 mb-2xs">{label}</label>;
    $[20] = label;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== maxLabel || $[23] !== minLabel) {
    t6 = (minLabel || maxLabel) && <div className="text-app-caption-1 flex justify-between"><span>{minLabel}</span><span>{maxLabel}</span></div>;
    $[22] = maxLabel;
    $[23] = minLabel;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== disabled) {
    t7 = (t8, state) => {
      const {
        key,
        style,
        ...props_0
      } = t8;
      if (state.index === 0) {
        return <div key={key} {...props_0} style={{
          ...style,
          top: 6
        }} className={clsx("h-2xs rounded-l-xs", {
          "bg-neutral-50": disabled,
          "bg-primary-800": !disabled
        })} />;
      }
      return <div key={key} {...props_0} style={{
        ...style,
        top: 6
      }} className={clsx("h-2xs rounded-r-xs", {
        "bg-neutral-50": disabled,
        "bg-neutral-100": !disabled
      })} />;
    };
    $[25] = disabled;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== ariaDescribedBy || $[28] !== ariaLabel || $[29] !== disabled || $[30] !== formatValue || $[31] !== label || $[32] !== rawMax || $[33] !== rawMin || $[34] !== suffix) {
    t8 = (t9, state_0) => {
      const {
        key: key_0,
        className: className_0,
        ...props_1
      } = t9;
      const actualValue = Number((state_0.valueNow + rawMin).toFixed(10));
      return <div key={key_0} className="group relative focus:outline-none" {...props_1} aria-label={ariaLabel ?? label} aria-describedby={ariaDescribedBy} aria-valuemin={rawMin} aria-valuemax={rawMax} aria-valuenow={actualValue} aria-valuetext={formatValue?.(actualValue) ?? `${actualValue}${suffix ? ` ${suffix}` : ""}`}><div className={clsx("absolute left-1/2 -translate-x-1/2 -translate-y-3xs active:cursor-grabbing p-3xs  rounded-full", className_0, {
          "cursor-not-allowed": disabled,
          "cursor-grab hover:bg-primary-800 hover:bg-opacity-10": !disabled
        })}><div className={clsx("w-2s h-2s bg-neutral-0 rounded-full border border-neutral-50 flex items-center justify-center outline-none drop-shadow-md group-focus-visible:ring-2 group-focus-visible:ring-primary-800 group-focus-visible:ring-offset-2")} /></div></div>;
    };
    $[27] = ariaDescribedBy;
    $[28] = ariaLabel;
    $[29] = disabled;
    $[30] = formatValue;
    $[31] = label;
    $[32] = rawMax;
    $[33] = rawMin;
    $[34] = suffix;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== rawMin || $[37] !== suffix || $[38] !== value) {
    t9 = t10 => {
      const {
        key: key_1,
        ...props_2
      } = t10;
      return <div key={key_1} {...props_2} className="flex-col flex items-center top-2s"><span className="h-2xs w-[1px] bg-neutral-100 block" /><span className={clsx("text-app-body-2 absolute left-1/2 top-2xs -translate-x-1/2", {
          "text-primary-800": key_1 === value
        })}>{(key_1 as number) + rawMin}{suffix}</span></div>;
    };
    $[36] = rawMin;
    $[37] = suffix;
    $[38] = value;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== disabled || $[41] !== forwardedProps || $[42] !== max || $[43] !== onChange || $[44] !== t7 || $[45] !== t8 || $[46] !== t9 || $[47] !== value) {
    t10 = <ReactSlider {...forwardedProps} disabled={disabled} className="w-full active:cursor-grab relative h-3s" value={value} onChange={onChange} renderTrack={t7} thumbActiveClassName="bg-primary-800 bg-opacity-10" renderThumb={t8} renderMark={t9} min={0} max={max} />;
    $[40] = disabled;
    $[41] = forwardedProps;
    $[42] = max;
    $[43] = onChange;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
    $[47] = value;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  if ($[49] !== className || $[50] !== t10 || $[51] !== t5 || $[52] !== t6) {
    t11 = <div className={className}>{t5}{t6}{t10}</div>;
    $[49] = className;
    $[50] = t10;
    $[51] = t5;
    $[52] = t6;
    $[53] = t11;
  } else {
    t11 = $[53];
  }
  return t11;
};
export default Slider;